import { render } from "./CreateAsset.vue?vue&type=template&id=42321378&scoped=true"
import script from "./create_asset.js?vue&type=script&lang=js&external"
export * from "./create_asset.js?vue&type=script&lang=js&external"

import "./CreateAsset.vue?vue&type=style&index=0&id=42321378&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42321378"]])

export default __exports__